import React from "react";
import useEmpresasLogic from "./hooks/useEmpresasLogic";
import EmpresasView from "./pages/EmpresasView.jsx";

export default function Empresas() {
  const logic = useEmpresasLogic();
  return <EmpresasView {...logic} />;
}

